import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

const useLanguageDirection = (languageCode: string = '') => {
	const {managerRepository} = useGeneralProvider();

	return managerRepository.getLanguagesMgr().getLanguageAttributes(languageCode);
};

export default useLanguageDirection;
